//ready function, when this file is totally ready
import { ReinosMaps } from '../core'

ReinosMaps.prototype.ready = function (callback) {
  this.on('maps.ready', callback)
}
